import * as React from "react";

import connectToList from "../../store/list";

import GenButton from "../Gen/Button";
import GenListDisplay from "../Gen/ListDisplay";
import GenMore from "../Gen/More";
import GenSelectBar from "../Gen/SelectBar";

import DocumentListControls from "../Document/ListControls";

import { documentDisplayTitle } from "../../src/document_display_title";

interface GroupDocumentDeleteBatchSelectListProps {
  groups: Array<GroupSnakeModel>;
  groupDocuments: ConnectedList<GroupDocumentSnakeModel>;
}

function GroupDocumentDeleteBatchSelectList(props: GroupDocumentDeleteBatchSelectListProps) {
  const {
    groups,
    groupDocuments,
  } = props;

  React.useEffect(() => {
    groupDocuments.mountList("/group_documents/delete_batch");
  }, []);

  const [isSubmitLoading, setIsSubmitLoading] = React.useState(false);
  const [groupId, setGroupId] = React.useState<number>();

  const handleSubmitButton = React.useCallback(() => {
    if (groupDocuments.selected.length === 0) {
      alert("Nothing Selected! You must select at least one item to remove.");
      return;
    }

    const data = {
      groupDocumentIds: groupDocuments.selected.map((groupDocument) => groupDocument.id),
      groupId: groupId,
    };

    setIsSubmitLoading(true);

    fetch("/group_documents/destroy_batch", {
      method: "DELETE",
      body: JSON.stringify(data),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) { throw new Error(`${response.status} response`); }

        return response.json();
      })
      .then(Turbo.visit("/documents"))
      .catch(() => {
        setIsSubmitLoading(false);
      });
  }, [groupId, groupDocuments.selected]);

  return(
    <div>
      <div className="submit-panel">
        <h1>Revoke Cases From Group</h1>
        <GenButton
          name="Revoke"
          highlighted
          loading={isSubmitLoading}
          onClick={handleSubmitButton}
        />
      </div>
      <div className="panel">
        <label>Group To Revoke From:</label>
        <select value={groupId} onChange={(event) => setGroupId(parseInt(event.target.value))}>
          {groups.map((group) => <option value={group.id}>{group.name}</option>)}
        </select>
      </div>
      <GenSelectBar
        {...groupDocuments}
        itemType="case(s)"
      />
      <DocumentListControls
        documents={groupDocuments}
      />
      <GenListDisplay
        {...groupDocuments}
        renderItem={(groupDocument) => <span>{documentDisplayTitle(groupDocument.document)}</span>}
      />
      <GenMore
        {...groupDocuments}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(GroupDocumentDeleteBatchSelectList, ["groupDocuments"]);
